import { GLOSSARY_PAGE, WALL_OF_FAME_ROUTE } from 'constants/navigation'

export const FDR_PERSISTENT_HEADER_VARIANTS = Object.freeze({
  BRAND: 'brand',
  ARTICLE: 'article',
})

const BRAND_ROUTES = ['/contact/', '/reviews/', WALL_OF_FAME_ROUTE]

const ARTICLE_ROUTE_PREFIXES = [GLOSSARY_PAGE]

const withTrailingSlash = (path) => (path.endsWith('/') ? path : `${path}/`)

/**
 * Returns which legacy persistent header presentation a FDR multisite page uses on mobile,
 * or null when the page keeps the floating sticky footer.
 * @param {string} pathname - Actual pathname (FDR uses trailing slashes, but both forms match)
 * @returns {'brand' | 'article' | null}
 */
export const getFdrPersistentHeaderVariant = (pathname) => {
  if (!pathname) return null

  const path = withTrailingSlash(pathname)

  if (BRAND_ROUTES.includes(path)) return FDR_PERSISTENT_HEADER_VARIANTS.BRAND
  if (ARTICLE_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    return FDR_PERSISTENT_HEADER_VARIANTS.ARTICLE
  }

  return null
}
